<template>
  <div id="user-page" class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>{{pageTitle}}</h5>
      </div>
      <div class="col-3 d-flex justify-content-end">
        <button id="destroyBtn" type="button" class="btn-sm btn-outline-danger btn_left" v-on:click="destroy">削除する</button>
        <button id="backBtn" type="button" class="btn-sm btn-outline-info" v-on:click="back">キャンセルする</button>
      </div>
    </div>
    <div id="register_form" class="row">
      <div class="col-1">
      </div>
      <div class="col-8">
        <form @submit.prevent="modify(null)">
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>外線番号</label>
              </div>
              <div class="col-9">
                <input type="text" maxlength="13" v-model="phoneNumber" class="form-control" autocomplete="off" :placeholder="[[phoneNumberDisplayHolder]]" required>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>内線番号</label>
              </div>
              <div class="col-9">
                <input type="text" maxlength="13" v-model="extensionNumber" class="form-control" autocomplete="off" :placeholder="[[extensionNumberDisplayHolder]] ">
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>表示名</label>
              </div>
              <div class="col-9">
                <input type="text" maxlength="70" v-model="contactName" class="form-control" autocomplete="off" :placeholder="[[contactNameDisplayHolder]]">
              </div>
            </div>
          </div>
          <button id="register_button" type="submit" class="btn btn-info btn btn-block">更新する</button>
        </form>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import authority from '../../authority'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'Modify',
  mixins: [sessions,path,headers],
  props: ['realms','serviceName'],
  data: function(){
    return {
      message: '',
      phoneNumber: '',
      extensionNumber: '',
      contactName: '',
      originalPhoneNumber: '',
      originalExtensionNumber: '',
      originalContactName: '',
      pairId: ''
    }
  },
  computed: {
    isSuper: function () {
      return Number(this.$store.state.user.privilege) === authority.isSuper
    },
    isMessage: function () {
      return this.message.length > 0
    },
    required: function () {
      return this.groups.length > 1
    },
    pageTitle: function (){
      return '外線に割り当てる内線番号を更新'
    },
    phoneNumberDisplayHolder:function (){
      return '外線番号（必須）'
    },
    extensionNumberDisplayHolder:function (){
      return '内線番号'
    },
    contactNameDisplayHolder:function (){
      return '表示名'
    }
  },
  beforeMount() {
    this.pairId = this.$route.params.id; 
  },
  mounted() {
    this.$cognito.isAuthenticated().then((session) => {
      if(session){
        var accessToken = this.getAccessToken(this.$cognito,session)
        axios.get("/api/standardPhone/" + this.pairId, {
          headers: this.headers(accessToken)
        }).then(response => {
          var pair = response.data.data.pair
          this.phoneNumber = pair.phoneNumber
          this.extensionNumber = pair.extensionNumber
          this.contactName = pair.contactName
          this.originalPhoneNumber = pair.phoneNumber
          this.originalExtensionNumber = pair.extensionNumber
          this.originalContactName = pair.contactName
        }).catch(err => {
          this.message = err.message
        })
      }
    }).catch((err) => {
      this.message = err.message
    })
  },
  methods: {
    modify(swapTargetId) {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          const phonePattern = /^[\d-]+$/;
          if (!phonePattern.test(this.phoneNumber) || this.phoneNumber.replaceAll('-','').length > 11) {
            this.message = '外線番号の形式が正しくありません。'
            return
          }
          const extensionPattern = /^[\d#*]+$/;
          if (this.extensionNumber && !extensionPattern.test(this.extensionNumber)) {
            this.message = '内線番号の形式が正しくありません。'
            return
          }
          axios.put("/api/standardPhone/" + this.pairId, {
              phoneNumber: this.phoneNumber.replaceAll('-',''),
              hospitalId: this.$store.getters.hospital.id,
              extensionNumber: this.extensionNumber,
              contactName: this.contactName,
              swapTargetId: swapTargetId
          },{
            headers: this.headers(accessToken)
          }).then(response => {
            var res = response.data;
            if(res.errorMessage) {
              this.message = res.errorMessage
            } else {
              alert('更新されました。');
              this.$router.replace(this.replacePath(this.$cognito,this.realms,'/contacts/standardPhone/index'))
            }
          }).catch(err => {
            this.message = err.message
          })
        }
      }).catch((err) => {
          this.message = err.message
      })
    },
    back() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/contacts/standardPhone/index'))
    },
    destroy() {
      if(confirm('削除してもよろしいですか?')){
        this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          axios.delete("/api/standardPhone/" + this.pairId, {
              headers: this.headers(accessToken)
          }).then(response => {
            var res = response.data;
            if(res.errorMessage) {
              this.message = res.errorMessage
            } else {
              alert('削除されました。');
              this.$router.replace(this.replacePath(this.$cognito,this.realms,'/contacts/standardPhone/index'))
            }
          }).catch(err => {
            this.message = err.message
          })
        }}).catch((err) => {
          this.message = err.message
        })
      }
    }
  }
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
.btn_right {
  float:right;
}
#destroyBtn {
  margin-right: 10px;
}
#modify_button {
  margin-top: 30px;
}
.times-solid{
  cursor: pointer;
  height: 15px;
  width: 15px;
}
.form-table{
  margin-top: 5px;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>